import config from 'config';
import { PerCountryConfig, LanguageType } from 'types';

const CURRENCY_CONFIG: PerCountryConfig = {
  ro: 'ron',
  pl: 'zł',
  cz: 'czk',
};

export const useCurrency = () => {
  const currency = CURRENCY_CONFIG[config.LANGUAGE as LanguageType];

  return currency;
};
